import * as React from "react";

const SvgRefluxL = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="353"
    height="91"
    fill="none"
    viewBox="0 0 353 91"
    {...props}
  >
    <path
      fill={rackColor}
      d="M181.738 68H353l-8.738 23H173zM8.738 0H180l-8.738 23H0z"
    ></path>
      <path
      d="M181.738 68H353l-8.738 23H173zM8.738 0H180l-8.738 23H0z"
      fill="none"
      stroke="black"
      strokeWidth="0.8"
    />
  </svg>
);

export default SvgRefluxL;
